import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function summaryReducer(state = initialState.batchFileSummary, action) {
    switch (action.type) {
        case types.LOAD_SUMMARY_SUCCESS:
            return action.batchFileSummary;
        default:
            return state;
    }
}
